var map = {
	"./category_commodities.svg": 98978,
	"./category_crypto.svg": 94476,
	"./category_currencies.svg": 26290,
	"./category_equities.svg": 92562,
	"./category_indices.svg": 5670,
	"./category_stocks.svg": 42514
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41572;